import React from 'react';
import { connect } from 'react-redux';
import { func, bool } from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import DropDownTitled from './DropDownTitled';
import { Metric as IMetric } from '../models';
import { Metric } from '../constants';
import { isCensusView } from '../selectors/router';

const MetricSelector = ({
  labelColor,
  value,
  onChange,
  withTitle,
  inDataSettings = false,
  censusView,
}) => (
  <DropDownTitled
    labelStyle={{ color: labelColor }}
    style={{ width: '200px' }}
    value={value}
    onChange={(e, i, val) => onChange(val)}
    title={withTitle ? 'Measure:' : null}
    iconStyle={{
      fill: inDataSettings ? 'rgba(0, 0, 0, .87)' : 'rgba(255, 255, 255, 0.93)',
    }}
  >
    <MenuItem
      value={Metric.RATE}
      primaryText="Rate per 100k"
      disabled={censusView}
    />
    <MenuItem value={Metric.TOTAL} primaryText="Total Number" />
  </DropDownTitled>
);

MetricSelector.propTypes = {
  value: IMetric.isRequired,
  onChange: func.isRequired,
  withTitle: bool.isRequired,
};

export default connect(state => ({
  censusView: isCensusView(state),
}))(MetricSelector);



// WEBPACK FOOTER //
// ./src/components/MetricSelector.jsx